// extracted by mini-css-extract-plugin
export default {"loaderContainer":"AddEditArticle_loaderContainer__mFEl+"};